import { useState } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { TRIAL_DAYS } from '@mirai/shared';
import s from './Faq.module.css';

const FAQS = [
  {
    q: 'トライアル期間中に料金は発生しますか？',
    a: `いいえ。${TRIAL_DAYS}日間は完全無料でご利用いただけます。クレジットカードの登録も不要です。`,
  },
  {
    q: 'データの移行は可能ですか？',
    a: 'はい。CSV一括インポート機能を標準搭載しています。導入サポートも無料で提供いたします。',
  },
  {
    q: 'セキュリティ対策は？',
    a: 'SSL/TLS暗号化、データの自動バックアップ、テナントごとの完全分離されたデータベース設計を採用しています。',
  },
  {
    q: '契約期間の縛りはありますか？',
    a: '月額プランは1ヶ月単位でいつでも解約可能です。年間契約で20%割引もご用意しています。',
  },
  {
    q: '既存のポータルサイトとの連携は？',
    a: 'SUUMO、HOME\'S、at homeへの自動入稿に対応。物件情報の更新もリアルタイムで反映されます。',
  },
];

export function Faq() {
  const ref = useScrollReveal<HTMLElement>();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className={`${s.section} reveal`} ref={ref}>
      <div className={s.inner}>
        <h2 className={s.title}>よくある質問</h2>
        <div className={s.list}>
          {FAQS.map((faq, i) => (
            <div key={i} className={`${s.item} ${openIndex === i ? s.open : ''}`}>
              <button className={s.question} onClick={() => toggle(i)}>
                <span>{faq.q}</span>
                <span className={`${s.chevron} ${openIndex === i ? s.chevronOpen : ''}`}>&#9660;</span>
              </button>
              <div className={`${s.answer} ${openIndex === i ? s.answerOpen : ''}`}>
                <div className={s.answerInner}>{faq.a}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
